import React, { useEffect, useState } from 'react';

const UProgressBar = ({
  color = 'blue',
  percentage,      // If provided → static mode
  duration,        // If provided → animated mode
  animate = false,
  style = {},
  className = '',
  showPercent = false,
  onComplete,
}) => {
  const [progress, setProgress] = useState(percentage || 0);

  useEffect(() => {
    // If "duration" is provided → run animation mode
    if (duration && !percentage && percentage !== 0) {
      let start = 0;
      const intervalTime = 1500; // update every 50ms
      const increment = 100 / (duration / intervalTime);

      const interval = setInterval(() => {
        start += increment;
        if (start >= 100) {
          start = 100;
          clearInterval(interval);
          if (onComplete) onComplete();
        }
        setProgress(Math.floor(start));
      }, intervalTime);

      return () => clearInterval(interval);
    } 
    // else static mode → just set percentage
    else {
      setProgress(percentage || 0);
    }
  }, [duration, percentage, onComplete]);

  return (
    <div className={`u_progress-bar ${className}`} style={style}>
      <span className={color || 'blue'} style={{ width: `${progress || 0}%`, transition: animate ? 'width 1s ease-in-out' : 'width 0.5s ease-in-out' }} />
    </div>
  );
};

export default UProgressBar;

